import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {retry, catchError, map} from 'rxjs/operators';

import { NewsArticles, Podcast, SearchStaticContent, SearchResults } from '../Models/common.model';


@Injectable({
  providedIn: 'root'
})
export class SearchFilterService {
    private apiURL = window.location.href;

    constructor(private http: HttpClient) {
      
    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }
    getNewsArticles(): Observable<NewsArticles[]> {
        var backToTopstring = this.apiURL.indexOf('#');
        if (backToTopstring != -1) {
            this.apiURL = this.apiURL.substring(0, backToTopstring);
        }
        return this.http.get<NewsArticles[]>(this.apiURL + '/GetPagesJson/')
            .pipe(
                map(data => this.camelToPascalCase<NewsArticles[]>(data)),
                retry(1),
                catchError(this.handleError)
            )
    }

    // Helper function to actually transform camelCase to PascalCase
    private camelToPascalCase<T>(data: any): T {
        if (data === null || data === undefined) {
            return data;
        }

        // Handle arrays
        if (Array.isArray(data)) {
            return data.map(item => this.camelToPascalCase(item)) as unknown as T;
        }

        // Handle objects
        if (typeof data === 'object') {
            const result = {};

            for (const key in data) {
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                    // Convert first character to uppercase to create PascalCase
                    const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);

                    // Recursively convert nested objects and arrays
                    result[pascalKey] = this.camelToPascalCase(data[key]);
                }
            }

            return result as T;
        }

        // Return primitives unchanged
        return data as unknown as T;
    }

    getInternalNewsArticles(p, searchKeyword): Observable<SearchResults<NewsArticles>> {
        var backToTopstring = this.apiURL.indexOf('#');
        if (backToTopstring != -1) {
            this.apiURL = this.apiURL.substring(0, backToTopstring);
        }
        return this.http.get<SearchResults<NewsArticles>>(this.apiURL + '/GetSearchResults/?p=' + p + "&" + "q=" + searchKeyword)         
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getfilterby(): Observable<string[]> {
        return this.http.get<string[]>(this.apiURL + '/GetFiltersJson/')         
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getPagetitleErrormsg(): Observable<SearchStaticContent> {
        return this.http.get<SearchStaticContent>(this.apiURL + '/GetStaticDataJson/')
            .pipe(
                map(data => this.camelToPascalCase<SearchStaticContent>(data)),
                retry(1),
                catchError(this.handleError)
            )
    }
    
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

    getPodcasts(): Observable<Podcast[]> {
        return this.http.get<Podcast[]>(this.apiURL + '/GetPagesJson/')
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }
}
